import type { IBrand } from "../../../../types/models/brands.models.types";
import type { IPagination } from "../../../../types/models/pagination.models.types";
import { useGetHttp } from "../../http.hook";

interface IResponse {
  brands: Array<IBrand>;
  pagination: IPagination;
}

export function useGetBrandsAdminHttp() {
  return useGetHttp<IResponse>({
    path: "/admin/brands",
  });
}
